/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import Grid, { GridProps, GridSize } from '@material-ui/core/Grid'
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints'
import { JSONSchema6 } from 'json-schema'
import React, { ComponentType, ReactElement } from 'react'
import { FieldProps } from 'react-jsonschema-form'
import ObjectField from 'react-jsonschema-form/lib/components/fields/ObjectField'
import { retrieveSchema } from 'react-jsonschema-form/lib/utils'

const ItemLayout = ({
  children,
  itemProps,
  hidden = false,
}: {
  children: ReactElement
  hidden?: boolean
  itemProps: GridProps
}) => (
  <Grid item style={{ display: hidden ? 'none' : 'flex' }} {...itemProps}>
    {children}
  </Grid>
)

type LayoutRow = {
  [key: string]: { [breakpoint in Breakpoint]: GridSize } & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    doShow?: ({ formData }: { formData: { [key: string]: any } }) => boolean
    render?: ComponentType
  }
}

export default class GridField extends ObjectField {
  state = {}

  render() {
    const {
      uiSchema,
      errorSchema,
      idSchema,
      required = false,
      disabled = false,
      readonly = false,
      onBlur,
      onFocus,
      registry,
      schema: givenSchema,
      formData,
    } = this.props
    const { definitions, fields, formContext } = registry
    const schema = retrieveSchema(givenSchema, definitions)

    const { SchemaField, TitleField, DescriptionField } = fields
    const title = schema.title === undefined ? '' : schema.title

    const layout: LayoutRow[] = uiSchema['ui:layout']

    return (
      <>
        {title && (
          <TitleField
            formContext={formContext}
            id={`${idSchema.$id}__title`}
            required={required}
            title={title}
          />
        )}
        {schema.description && (
          <DescriptionField
            description={schema.description}
            formContext={formContext}
            id={`${idSchema.$id}__description`}
          />
        )}
        {layout.map((row, rowIndex) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <Grid key={rowIndex} container spacing={2} wrap="wrap">
              {Object.keys(row).map((name, itemIndex) => {
                const { render, ...itemProps } = row[name]
                if (!schema.properties) return null

                const key = [rowIndex, itemIndex].join('/')
                const fieldSchema = schema.properties[name]
                if (fieldSchema && errorSchema) {
                  return (
                    <ItemLayout
                      key={key}
                      hidden={uiSchema[name]['ui:widget'] === 'hidden'}
                      itemProps={itemProps}
                    >
                      <SchemaField
                        disabled={disabled}
                        errorSchema={errorSchema[name]}
                        formData={formData[name]}
                        idSchema={idSchema[name]}
                        name={name}
                        readonly={readonly}
                        registry={registry as FieldProps['registry']}
                        required={this.isRequired(name)}
                        schema={fieldSchema as JSONSchema6}
                        uiSchema={uiSchema[name]}
                        onBlur={onBlur}
                        onChange={this.onPropertyChange(name)}
                        onFocus={onFocus}
                      />
                    </ItemLayout>
                  )
                }

                let UIComponent: ComponentType<Partial<FieldProps>> = () => null
                if (render) {
                  UIComponent = render
                }

                return (
                  <ItemLayout key={key} itemProps={itemProps}>
                    <UIComponent
                      errorSchema={errorSchema}
                      formData={formData}
                      name={name}
                      registry={registry as FieldProps['registry']}
                      schema={schema}
                      uiSchema={uiSchema}
                    />
                  </ItemLayout>
                )
              })}
            </Grid>
          )
        })}
      </>
    )
  }
}
